module.exports = __webpack_public_path__ + "img/5.3f6e96ca.gif";